import React from 'react'
import HelpCenter, {
  HelpCenterContent
} from '../../routes/HelpCenter/HelpCenter'
import Head from 'next/head'
import { useRouter } from 'next/router'

const Routes = () => {
  const router = useRouter()

  return (
    <>
      <Head>
        <title>{`Help Center - DecorMatters | ${
          (router?.query?.params &&
            router?.query?.params[0].replaceAll('-', ' ')) ||
          ''
        }`}</title>
        <meta
          name="description"
          content={`${'Get answers to your questions, learn how to use DecorMatters, and troubleshoot issues.'} | ${
            (router?.query?.params &&
              router?.query?.params[0].replaceAll('-', ' ')) ||
            ''
          }`}
        />
        <meta name="twitter:card" content="summary" />
        <meta
          name="twitter:site"
          content={`https://www.decormatters.com/help-center`}
        />
        <meta name="twitter:title" content="Help Center - DecorMatters" />
        <meta name="twitter:site" content="@decormattersapp" />
        <meta
          property="og:url"
          content={`https://www.decormatters.com/help-center`}
        />
        <meta property="og:title" content="Help Center - DecorMatters" />
        <meta
          property="og:description"
          content="Get answers to your questions, learn how to use DecorMatters, and troubleshoot issues."
        />
      </Head>
      <HelpCenterContent />
    </>
  )
}

export default Routes
